import { render, staticRenderFns } from "./AttachmentDetail.vue?vue&type=template&id=90ba1ea4&scoped=true"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDetail.vue?vue&type=style&index=0&id=90ba1ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba1ea4",
  null
  
)

export default component.exports